import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-blue-900 py-20" aria-labelledby="faq-title" data-id="element-65" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-66" data-mp="1cfjcm29v4iov">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-white md:text-4xl" data-id="element-67" data-mp="1ccndwbq6xpzd">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-68" data-mp="2546zu3e69i52">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-lg border bg-blue-950 transition-colors duration-200 ease-out ${isOpen ? 'border-slate-300' : 'border-slate-300/20'}`} data-id="element-69" data-mp="1v580xcj7l0v9" data-mpi={index}>
                <h3 data-id="element-70" data-mp="jo9f3tra2pmr">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-sans font-bold text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-slate-300/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-71" data-mp="jrxbd0o3xq56">
                    <span data-id="element-72" data-mp="1fqqb32oh0797">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-300 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-73" data-mp="11wpd4b5ceo9w" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-74" data-mp="wxw52y8trph4">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-75" data-mp="iyd02ebb8u91">
                      <p className="border-t border-slate-300/20 px-5 py-4 leading-relaxed text-slate-300 sm:px-6" data-id="element-76" data-mp="2kw6r0bcuc8d9">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}